import { Layout } from 'App/Layout/Layout';
import { Login } from 'Views/Login/Login';
import { authRoutes } from 'Views/Login/routes';
import { useAuth } from 'hooks/useAuth';
import { useSessionStorage } from 'hooks/useSessionStorage';
import jwt_decode from 'jwt-decode';
import { ComponentType, ReactNode } from 'react';
import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';
import { useAuthorizedRoutes } from './authorizedRoutes';

const validateToken = (token: any) => {
	const decoded: any = jwt_decode(token);
	const currentDate = new Date();
	const expiresDate = new Date(decoded.exp * 1000);
	return currentDate.getTime() <= expiresDate.getTime();
};

type PrivateRouteProps = {
	isActive: boolean;
	children: ReactNode;
};

const PrivateRoute = ({ isActive, children }: PrivateRouteProps) => {
	const { isAuthenticated, isLoading } = useAuth();

	let isValid = true;
	const { getSessionStorage } = useSessionStorage();
	const token = getSessionStorage('idToken');

	if (token) {
		isValid = validateToken(token);
	}

	if (isLoading) return null;
	if (!isAuthenticated) return <Navigate to="/login" replace />;
	if (!isValid) return <Navigate to="/login" replace />;
	if (!isActive) return <Navigate to="/not-authorized" replace />;

	return <Layout>{children}</Layout>;
};

export const Routes = (): JSX.Element => {
	const authorizedRoutes = useAuthorizedRoutes();

	return (
		<RouterRoutes>
			<Route element={<Login />}>{authRoutes}</Route>

			{authorizedRoutes.flatMap((route) => {
				const Component = route.component as ComponentType;
				const paths = Array.isArray(route.path) ? route.path : [route.path];

				return paths.map((path) => (
					<Route
						key={path}
						path={path}
						element={
							<PrivateRoute isActive={route.active}>
								<Component />
							</PrivateRoute>
						}
					/>
				));
			})}

			<Route path="*" element={<Navigate to="/" replace />} />
		</RouterRoutes>
	);
};
